/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.StandardizedInstallTypeRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './StandardizedInstallTypeRpc';
import * as Queries from './StandardizedInstallTypeRpc.dfc.new';
import type { AdditionalContextArgs } from './StandardizedInstallTypeRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;
type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGetStandardizedInstallTypeQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetStandardizedInstallTypeResponseType>,
    References.GetStandardizedInstallTypeRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getStandardizedInstallType',
            References.GetStandardizedInstallTypeResponseType
          >
        : References.GetStandardizedInstallTypeResponseType)
    | undefined;
};

export function useGetStandardizedInstallTypeQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetStandardizedInstallTypeResponseType>,
    References.GetStandardizedInstallTypeRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetStandardizedInstallTypeQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_STANDARDIZED_INSTALL_TYPE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getStandardizedInstallType: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetStandardizedInstallTypeQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetStandardizedInstallTypeQueryReturn<T>;
}

type UseGetStandardizedInstallTypeLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetStandardizedInstallTypeResponseType>,
    References.GetStandardizedInstallTypeRequestType,
    T extends true
      ? Record<
          'getStandardizedInstallType',
          References.GetStandardizedInstallTypeResponseType
        >
      : References.GetStandardizedInstallTypeResponseType
  >;

export function useGetStandardizedInstallTypeLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetStandardizedInstallTypeResponseType>,
    References.GetStandardizedInstallTypeRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetStandardizedInstallTypeLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_STANDARDIZED_INSTALL_TYPE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getStandardizedInstallType: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetStandardizedInstallTypeLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetStandardizedInstallTypeLazyQueryReturn<T>;
}

type UseGetStandardizedInstallTypeSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetStandardizedInstallTypeResponseType>,
    References.GetStandardizedInstallTypeRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getStandardizedInstallType',
        References.GetStandardizedInstallTypeResponseType
      >
    : References.GetStandardizedInstallTypeResponseType;
};

export function useGetStandardizedInstallTypeSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetStandardizedInstallTypeResponseType>,
    References.GetStandardizedInstallTypeRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetStandardizedInstallTypeSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_STANDARDIZED_INSTALL_TYPE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getStandardizedInstallType: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetStandardizedInstallTypeSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetStandardizedInstallTypeSuspenseQueryReturn<T>;
}

type UseGetStandardizedInstallTypeFromNa1QueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetStandardizedInstallTypeFromNa1ResponseType>,
    References.GetStandardizedInstallTypeFromNa1RequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getStandardizedInstallTypeFromNa1',
            References.GetStandardizedInstallTypeFromNa1ResponseType
          >
        : References.GetStandardizedInstallTypeFromNa1ResponseType)
    | undefined;
};

export function useGetStandardizedInstallTypeFromNa1Query<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<'result', References.GetStandardizedInstallTypeFromNa1ResponseType>,
    References.GetStandardizedInstallTypeFromNa1RequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetStandardizedInstallTypeFromNa1QueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_STANDARDIZED_INSTALL_TYPE_FROM_NA1_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getStandardizedInstallTypeFromNa1: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetStandardizedInstallTypeFromNa1QueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetStandardizedInstallTypeFromNa1QueryReturn<T>;
}

type UseGetStandardizedInstallTypeFromNa1LazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetStandardizedInstallTypeFromNa1ResponseType>,
    References.GetStandardizedInstallTypeFromNa1RequestType,
    T extends true
      ? Record<
          'getStandardizedInstallTypeFromNa1',
          References.GetStandardizedInstallTypeFromNa1ResponseType
        >
      : References.GetStandardizedInstallTypeFromNa1ResponseType
  >;

export function useGetStandardizedInstallTypeFromNa1LazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetStandardizedInstallTypeFromNa1ResponseType>,
    References.GetStandardizedInstallTypeFromNa1RequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetStandardizedInstallTypeFromNa1LazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_STANDARDIZED_INSTALL_TYPE_FROM_NA1_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getStandardizedInstallTypeFromNa1: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetStandardizedInstallTypeFromNa1LazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetStandardizedInstallTypeFromNa1LazyQueryReturn<T>;
}

type UseGetStandardizedInstallTypeFromNa1SuspenseQueryReturn<
  T extends boolean,
> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetStandardizedInstallTypeFromNa1ResponseType>,
    References.GetStandardizedInstallTypeFromNa1RequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getStandardizedInstallTypeFromNa1',
        References.GetStandardizedInstallTypeFromNa1ResponseType
      >
    : References.GetStandardizedInstallTypeFromNa1ResponseType;
};

export function useGetStandardizedInstallTypeFromNa1SuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetStandardizedInstallTypeFromNa1ResponseType>,
    References.GetStandardizedInstallTypeFromNa1RequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetStandardizedInstallTypeFromNa1SuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_STANDARDIZED_INSTALL_TYPE_FROM_NA1_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getStandardizedInstallTypeFromNa1: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetStandardizedInstallTypeFromNa1SuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetStandardizedInstallTypeFromNa1SuspenseQueryReturn<T>;
}

type UseUpdateStandardizedInstallTypeForDraftListingMutationReturn<
  T extends boolean,
> = MutationTupleOverride<
  Record<
    'result',
    References.UpdateStandardizedInstallTypeForDraftListingResponseType
  >,
  References.UpdateStandardizedInstallTypeForDraftListingRequestType,
  T extends true
    ? Record<
        'updateStandardizedInstallTypeForDraftListing',
        References.UpdateStandardizedInstallTypeForDraftListingResponseType
      >
    : References.UpdateStandardizedInstallTypeForDraftListingResponseType
>;

export function useUpdateStandardizedInstallTypeForDraftListingMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<
      'result',
      References.UpdateStandardizedInstallTypeForDraftListingResponseType
    >,
    References.UpdateStandardizedInstallTypeForDraftListingRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateStandardizedInstallTypeForDraftListingMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_STANDARDIZED_INSTALL_TYPE_FOR_DRAFT_LISTING_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateStandardizedInstallTypeForDraftListing: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateStandardizedInstallTypeForDraftListingMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateStandardizedInstallTypeForDraftListingMutationReturn<T>;
}
